module.exports = __webpack_public_path__ + "img/heart-fill.78922346.svg";